// src/components/common/CustomListToolbar.tsx

import React from 'react';
import {
  TopToolbar,
  CreateButton,
  ExportButton,
  FilterButton,
  useTranslate,
  ToolbarProps,
} from 'react-admin';
import { SxProps, styled } from '@mui/material';

// Estilos comunes para los botones principales para no repetirlos
const mainButtonStyles: SxProps = {
  backgroundColor: 'primary.main',
  mt:'2px',
  color: 'white',
  '&:hover': {
    backgroundColor: 'primary.dark',
    color: 'white',
  },
};

const StyledFilterButton = styled(FilterButton)(({ theme }) => ({
  '& .MuiButton-root': {
    mt:'2px',
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      color: theme.palette.primary.dark,
      backgroundColor: 'rgba(25, 118, 210, 0.04)',
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },
    '&:hover .MuiSvgIcon-root': {
      color: theme.palette.primary.dark,
    },
  },
}));


const StyledTopToolbar = styled(TopToolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  maxHeight: '45px',
  gap: theme.spacing(1),
}));

interface CustomListToolbarProps extends ToolbarProps {
  showFilterButton?: boolean;
  showCreate?: boolean;
  createLabel?: string;
  showExport?: boolean;
  children?: React.ReactNode;
}

export const CustomListToolbar: React.FC<CustomListToolbarProps> = (props) => {
  const {
    showFilterButton = false,
    showCreate = true,
    createLabel,
    showExport = true,
    children,
    ...rest
  } = props;
  const translate = useTranslate();

  const finalCreateLabel = createLabel ?? translate('ra.action.create');

  return (
    <StyledTopToolbar {...rest}>
      {children}

      {showFilterButton && <StyledFilterButton />}

      {showCreate && (
        <CreateButton
          label={finalCreateLabel}
          sx={mainButtonStyles}
        />
      )}

      {showExport && <ExportButton sx={mainButtonStyles} />}
    </StyledTopToolbar>
  );
};

export default CustomListToolbar;